export const OrgErrors = {
  no_contracts_for_any_ken: 'No contract found for any ken you need to set contract date manually.',
  no_valid_contract_add_seperatly:
    'No valid contract found for kens. you need to add these kens seperatly to set contract date manually.',
  switch_disabled: 'switch-disabled',
}
